import { css } from 'linaria';
import { breakpoints } from 'common/styles/breakpoints';

export const contentWrap = css`
  display: flex;
  width: 372px;
  padding: 0 !important;
  background-color: var(--background-secondary);
  border-radius: var(--rounding-m);

  ${breakpoints.to.desktop} {
    width: 100%;
  }

  &:hover {
    background-color: var(--control-minor);
    div[id='modal-opener-wrap'] {
      div {
        --i-color: var(--success-primary) !important;
      }
    }
  }
`;

export const imgStyle = css`
  width: 40px;
  height: 40px;
`;

export const operationalTextStyle = css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: left;
`;

export const imgWrap = css`
  height: 68px;
  padding: var(--space-175) 0 var(--space-175) var(--space-175);
`;

export const innerWrap = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding: var(--space-175);
`;

export const modalOpenerStyle = css`
  padding: var(--space-25) 0;
  margin-bottom: auto;

  ${breakpoints.only.mobile} {
    padding: var(--space-25);
  }
`;
